/*
  Project: Moenig
  Author: Luum GmbH
 */

import 'foundation-sites/dist/js/foundation';
import slick from './modules/slick';
import main from './modules/main';

const $ = require('jquery');

slick();
main();
$(document).foundation();



// WEBPACK FOOTER //
// ./src/scripts/app.js